import { Controller } from "@hotwired/stimulus"
import { showFlashMessage } from "../src/utils/flashMessage"

export default class extends Controller {
  copy() {
    navigator.clipboard.writeText(location.href)
      .then(() => {
        showFlashMessage("success", "求人のリンクをコピーしました！")
      })
      .catch((err) => {
        console.error('クリップボードへのコピーに失敗しました:', err)
      })
  }
}
